export default __webpack_public_path__ + "static/media/pruefzeugnis.8bae16cb.pdf";